/**
 * 账户服务
 */

import { apiClient } from './apiClient';
import { ProfitTimeRange } from '@/services/enums';

export interface PositionStatistics {
  todayPnL: number;
  totalPnL: number;
  totalTrades: number;
  winRate: number;
  avgProfitLossRatio: number;
  totalFee: number;
  totalFundingFee: number;
  maxDrawdown: number;
}

export class AccountService {
  /**
   * 获取交易历史
   */
  async getTradeHistory(instId?: string, limit: number = 100): Promise<any> {
    const response = await apiClient.get<any>('/account/orders', {
      params: {
        instId,
        limit,
        _t: Date.now(), // 添加时间戳破坏缓存
        _v: '4.0.0', // 添加版本号
      },
    });

    if (!response.success) {
      throw new Error(response.message || '获取交易历史失败');
    }

    return response.data;
  }

  /**
   * 获取未成交订单列表
   */
  async getPendingOrders(): Promise<any> {
    const response = await apiClient.get<any>('/account/pending-orders');

    if (!response.success) {
      throw new Error(response.message || '获取未成交订单失败');
    }

    return response.data;
  }

  /**
   * 获取历史持仓信息（从数据库）
   */
  async getAccountPositionsHistory(
    instId?: string,
    startDate?: string,
    endDate?: string,
    limit: number = 100,
    offset: number = 0,
  ): Promise<any> {
    const response = await apiClient.get<any>('/account/historical-positions', {
      params: {
        instId,
        startDate,
        endDate,
        limit,
        offset,
        _t: Date.now(), // 添加时间戳破坏缓存
        _v: '4.0.0', // 添加版本号
      },
    });

    if (!response.success) {
      throw new Error(response.message || '获取历史持仓信息失败');
    }

    return response.data;
  }

  /**
   * 获取持仓统计数据
   */
  async getPositionStatistics(timeRange: ProfitTimeRange = 'all'): Promise<PositionStatistics> {
    const response = await apiClient.get<PositionStatistics>('/account/position-statistics', {
      params: {
        timeRange,
        _t: Date.now(), // 添加时间戳破坏缓存
      },
    });

    if (!response.success) {
      throw new Error(response.message || '获取持仓统计数据失败');
    }

    return response.data;
  }
}

export const accountService = new AccountService();
